<template>
  <!-- xl-backtop样式名，需要自己在样式文件中定义这个样式内容 -->
  <!-- 全局的回到顶部组件，不是公共组件， -->
  <div class="arrow-up" v-if="visible" @click.stop="handleClick">
    <!--    <slot>-->
    <!-- 这里是返回顶部的图标 -->
    <!-- <i class="iconfont icon-guanwang-fanhuidingbu" /> -->
    <img src="@/assets/img/index/backTop.png" alt="" />
    <div>回到顶部</div>

    <!--    </slot>-->
  </div>
</template>

<script>
const cubic = (value) => Math.pow(value, 3)
const easeInOutCubic = (value) =>
  value < 0.5 ? cubic(value * 2) / 2 : 1 - cubic((1 - value) * 2) / 2

export default {
  name: 'BackTop',

  props: {
    bottomHeight: {
      type: Number,
      default: 361
    },
    visibilityHeight: {
      type: Number,
      default: 200
    },
    target: [String],
    right: {
      type: Number,
      default: 40
    },
    bottom: {
      type: Number,
      default: 40
    }
  },

  data() {
    return {
      el: null,
      container: null,
      visible: false,
      navTop: ''
    }
  },

  computed: {
    styleBottom() {
      return `${this.bottom}px`
    },
    styleRight() {
      return `${this.right}px`
    }
  },

  mounted() {
    this.init()
    this.navTop = document.querySelector('.head-box')
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    // 在组件生命周期结束的时候销毁。
    this.container.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('scroll', this.handleScroll, false)
  },
  methods: {
    handleScroll() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (this.$store.state.isCarInfo) {
        if (this.scrollTop < 1100) {
          this.navTop.style.visibility = 'unset'
        } else {
          this.navTop.style.visibility = 'hidden'
        }
      }
      // console.log(this.scrollTop)
      // 滚动距离 > 可视区高度
      this.visible =
        this.scrollTop >
        0.8 *
          (document.documentElement.clientHeight || document.body.clientHeight)
    },
    init() {
      this.container = document
      this.el = document.documentElement
      if (this.target) {
        this.el = document.querySelector(this.target)
        if (!this.el) {
          throw new Error(`target is not existed: ${this.target}`)
        }
        this.container = this.el
      }

      // 判断底部距离
      window.addEventListener('scroll', (e) => {
        if (!document.querySelector('.arrow-up')) {
          return false
        }

        let scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop

        // 变量 scrollHeight 是滚动条的总高度
        let scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight

        // 变量 windowHeight 是可视区的高度
        let windowHeight =
          document.documentElement.clientHeight || document.body.clientHeight

        // 变量scrollTop为当前页面的滚动条纵坐标位置
        // let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        // 滚动条到底部得距离 = 滚动条的总高度 - 可视区的高度 - 当前页面的滚动条纵坐标位置
        const scrollBottom = scrollHeight - windowHeight - scrollTop

        // 357-x = 260
        if (scrollBottom > this.bottomHeight - 97) {
          // console.log(scrollTop,scrollBottom)
          document.querySelector('.arrow-up').style.position = 'fixed'
          // 357-x = 98
          // document.querySelector('.arrow-up').style.bottom = (this.bottomHeight- 159) + "px";
          document.querySelector('.arrow-up').style.bottom = '98px'
          document.querySelector('.arrow-up').style.right = '10px'
        } else {
          // console.log(scrollBottom)
          // document.querySelector('.arrow-up').style.bottom = "358px";
          document.querySelector('.arrow-up').style.position = 'absolute'
          document.querySelector('.arrow-up').style.bottom =
            this.bottomHeight + 'px'
          document.querySelector('.arrow-up').style.right = '10px'
        }
      })
    },
    onScroll() {
      const scrollTop = this.el.scrollTop
      // console.log(scrollTop,this.visibilityHeight)
      this.visible = scrollTop >= this.visibilityHeight
    },
    handleClick(e) {
      this.scrollToTop()
      this.$emit('click', e)
    },
    scrollToTop() {
      const el = this.el
      const beginTime = Date.now()
      const beginValue = el.scrollTop
      const rAF =
        window.requestAnimationFrame || ((func) => setTimeout(func, 16))
      const frameFunc = () => {
        const progress = (Date.now() - beginTime) / 500
        if (progress < 1) {
          el.scrollTop = beginValue * (1 - easeInOutCubic(progress))
          rAF(frameFunc)
        } else {
          el.scrollTop = 0
        }
      }
      rAF(frameFunc)
    }
  }
}
</script>
<style lang="scss" scoped>
.arrow-up {
  //transition: all 0.2s linear;
  position: absolute;
  right: 2vw;
  bottom: -50px;
  padding: 14px 10px;
  font-size: 12px;
  background: #ffffff;
  box-shadow: 0 2px 7px 0 rgba(10, 49, 141, 0.02);
  border-radius: 4px;
  border: 1px solid #e7e7e7;
  text-align: center;
  cursor: pointer;
  img {
    width: 21px;
    height: 13px;
    margin: 0px auto;
  }
  div {
    margin-top: 5px;
    font-size: 12px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #2f3849;
  }
}

// .arrow-up:hover {
//   color: #0071EF;
// }
</style>
